module.exports = __webpack_public_path__ + "img/banner-TazzTME.ad328f23.jpg";